import { Action } from "@ngrx/store";

export enum PadlockTokenActionTypes {
  GetPadlockToken = "[PadlockToken] Get PadlockToken",
  GetPadlockTokenFromB2CToken = "[PadlockToken] Get PadlockTokenFromB2CToken",
  GetPadlockTokenSuccess = "[PadlockToken] Get PadlockToken Success",
  GetPadlockTokenFailure = "[PadlockToken] Get PadlockToken Failure",
  ProvisionUser = "[PadlockToken] Provision User",
  ProvisionUserSuccess = "[PadlockToken] Provision User Success",
  ProvisionUserFailure = "[PadlockToken] Provision User Failure",
}

export type PadlockTokenSource = "credential" | "b2c";

export class GetPadlockToken implements Action {
  readonly type = PadlockTokenActionTypes.GetPadlockToken;
  constructor(
    public email: string,
    public password: string,
  ) {}
}

export class GetPadlockTokenFromB2CToken implements Action {
  readonly type = PadlockTokenActionTypes.GetPadlockTokenFromB2CToken;
  constructor(public b2cToken: string) {}
}

export class GetPadlockTokenSuccess implements Action {
  readonly type = PadlockTokenActionTypes.GetPadlockTokenSuccess;
  constructor(
    public token: string,
    public source?: PadlockTokenSource,
  ) {}
}

export class GetPadlockTokenFailure implements Action {
  readonly type = PadlockTokenActionTypes.GetPadlockTokenFailure;
  constructor(
    public error: any,
    public source?: PadlockTokenSource,
  ) {}
}

export class ProvisionUser implements Action {
  readonly type = PadlockTokenActionTypes.ProvisionUser;
  constructor(
    public email: string,
    public password: string,
    public workspaceIDs: string[],
  ) {}
}

export class ProvisionUserSuccess implements Action {
  readonly type = PadlockTokenActionTypes.ProvisionUserSuccess;
  constructor(public email: string) {}
}

export class ProvisionUserFailure implements Action {
  readonly type = PadlockTokenActionTypes.ProvisionUserFailure;
  constructor(
    public email: string,
    public error: any,
  ) {}
}

export type PadlockTokenActions =
  | GetPadlockToken
  | GetPadlockTokenFromB2CToken
  | GetPadlockTokenSuccess
  | GetPadlockTokenFailure
  | ProvisionUser
  | ProvisionUserSuccess
  | ProvisionUserFailure;
